import React, { useMemo, useState, useCallback, useEffect } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../../assets/Vehicles/search.png";
import { Plus, ChevronLeft, ChevronRight, Calendar, Clock } from "lucide-react";
import close from "../../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../../assets/Vehicles/fill_chevron_down.png";
import customize from "../../../assets/Vehicles/customize.png";
import down from "../../../../src/assets/Vehicles/chevron_down.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import DatePicker from "react-datepicker";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";
import chevron_down from "../../../assets/Vehicles/chevron_down.png";
import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import MOCK_DATA from "../../Vehicles/MOCK_DATA.json";
import "../Vehicle_list/List.css";
import { geFuelHistoryListApi } from "../vehicle-api-new.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import editIcon from "../../../assets/svg/edit.svg";
import delIcon from "../../../assets/svg/delete.svg";
import DeleteModal from "../../common/delete-modal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import FuelFistoryForm from "./FuelHistoryCreate.jsx";
import { Tooltip } from "react-tooltip";
import FuelHistoryView from "./FuelHistoryView.jsx";
import { useGlobal } from "../../../GlobalContext.js";

export const FuelHistory = () => {
  const { rolePermissionList, userType } = useGlobal();

  const columns = [
    {
      header: "Date",
      accessorKey: "date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "VIN",
      accessorKey: "vin",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "License Plate",
      accessorKey: "lic_no",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Last KM",
      accessorKey: "last_km",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Current KM",
      accessorKey: "current_km",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Fuel Economy",
      accessorKey: "fuel_economy",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Fuel Qty",
      accessorKey: "fuel_qty",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Fuel Cost",
      accessorKey: "fuel_cost",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Fuel Type",
      accessorKey: "fuel_type",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minWidth: "150px",
            }}
          >
            <span>{info.getValue()}</span>
            <div className="click-actions">
              {checkPermission("Fuel History", "edit_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent triggering row click
                    handleEdit(info.row.original.id);
                  }}
                >
                  <img src={editIcon} alt="edit" />
                </button>
              )}
              {checkPermission("Fuel History", "delete_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(info.row.original.id);
                  }}
                >
                  <img src={delIcon} alt="delete" />
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const handleDelete = (id) => {
    console.log("sss", id);
    setDeleteId(id);
  };
  const [editId, setEditId] = useState(null);
  const data = useMemo(() => MOCK_DATA, []);
  // form date
  const [selectedDate, setSelectedDate] = useState();
  const [selectedDates, setSelectedDates] = useState(new Date());
  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");
  const sortByList = [
    /* {value:'name asc', label:'Name (Asc)'}, {value:'name desc', label:'Name (Desc)'}, */ {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];

  const [lastKMFilter, setLastKMFilter] = useState("");
  const [currentKMFilter, setCurrentKMFilter] = useState("");

  const [fuelHistoryList, setFuelHistoryList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const handleEdit = (id) => {
    console.log("sss", id);
    setEditId(id);
  };

  useEffect(() => {
    if (editId != null && editId !== 0) {
      setShow(true);
    }
  }, [editId]);

  useEffect(() => {
    getFuelHistoryList();
  }, [itemsPerPage, itemOffset, sortByValue, selectedDate]);

  useEffect(() => {
    const handler = setTimeout(() => {
      getFuelHistoryList();
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler); // cleanup old timer
    };
  }, [globalFilter, lastKMFilter, currentKMFilter]);

  const getFuelHistoryList = async () => {
    try {
      /* &from_date=${fromCreatedDate}&to_date=${toCreatedDate}&status=${selectedStatus}&sort_field=${sortField}&sort_dir=${sortDir} */
      const response = await geFuelHistoryListApi(`search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortByDir}&last_km=${lastKMFilter}&current_km=${currentKMFilter}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}`);
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setFuelHistoryList(response.data.histories);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % fuelHistoryList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: fuelHistoryList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  // offcanvas
  const [show, setShow] = useState(false);

  const handleClose = (response) => {
    if (!response || !response.data) {
      setShow(false);
      setEditId(null);
    } else {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      setShow(false);
      setEditId(null);
    }
    getFuelHistoryList();
  };
  const handleShow = () => setShow(true);

  const [showRowOffcanvas, setShowRowOffcanvas] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [editViewId, setEditViewId] = useState(null);
  const handleRowClick = (id) => {
    console.log("sss", id);
    setEditViewId(null);
    if (id != null && id !== 0) {
      setEditViewId(id);
      setShowRowOffcanvas(true);
    }
  };

  const handleCloseRowOffcanvas = () => {
    setShowRowOffcanvas(false);
    setEditViewId(null); // Optional, reset state
  };
  const details = [
    { label: "Type", value: "Toyota Terminal" },
    {
      label: "Group",
      value: "Chennai",
    },
    { label: "Kilometer", value: "95,000" },
    { label: "Assigned to", value: "Flyjac Logistics Private Limited" },
    { label: "Date", value: "23 May 2025" },
  ];

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null && deleteId !== 0) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getFuelHistoryList();
    }
  };
  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`fuel_history/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      <div className="bg-half-white">
        <div className=" rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
          <div className="d-flex p-3 flex-wrap align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Fuel History</p>
              {/*  <Dropdown>
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="bg-transparent fw-bold dark-purple border-0 fs-2 assigned-dropdowns p-0"
                  >
                    Fuel History
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">
                      Not assigned
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}
              <p className="text-muted">{listCount} records</p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                <img src={search} alt="search" />
                <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
              </div>
              {checkPermission("Fuel History", "create_permission") && (
                <Button className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white" onClick={handleShow}>
                  <Plus />
                  Add new
                </Button>
              )}
              <FuelFistoryForm id={editId} show={show} handleClose={handleClose} />
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
              <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {sortByValue.label}
                  <img src={fill_chevron_down} alt="chev down" />
                  <img src={close} alt="x" />
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {sortByList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        const arr = item.value.split(" ");
                        if (arr.length > 1) {
                          setSortByField(arr[0]);
                          setSortByDir(arr[1]);
                        }
                        setSortByValue(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="sort-tooltip" place="top" />
              </Dropdown>
              <div style={{ minWidth: "160px", maxWidth: "160px" }} className="search-wrapper d-flex align-items-center gap-2 bg-white search-border rounded-4 px-3 py-2" data-tooltip-id="lkm-tooltip" data-tooltip-content="Last KM">
                {/*  <img src={search} alt="search" /> */}
                <input
                  type="text"
                  placeholder="Last KM"
                  className="border-0 outline-0 rounded-3 text-purple"
                  value={lastKMFilter || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setLastKMFilter(value);
                  }}
                />
                {lastKMFilter !== "" && <img onClick={() => setLastKMFilter("")} src={close} alt="x" />}
                <Tooltip id="lkm-tooltip" place="top" />
              </div>
              <div style={{ minWidth: "160px", maxWidth: "160px" }} className="search-wrapper d-flex align-items-center gap-2 bg-white search-border rounded-4 px-3 py-2" data-tooltip-id="ckm-tooltip" data-tooltip-content="Current KM">
                {/* <img src={search} alt="search" /> */}
                <input
                  type="text"
                  placeholder="Current KM"
                  className="border-0 outline-0 rounded-3 text-purple"
                  value={currentKMFilter || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setCurrentKMFilter(value);
                  }}
                />
                {currentKMFilter !== "" && <img onClick={() => setCurrentKMFilter("")} src={close} alt="x" />}
                <Tooltip id="ckm-tooltip" place="top" />
              </div>

              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="date-tooltip" place="top" />
                {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>
            </div>
            {/* <Button className="bg-white border-purple rounded-pill text-dark-purple px-3">
                <img src={customize} alt="cuz" /> Customize table
              </Button> */}
          </div>

          <FuelHistoryView id={editViewId} showEdit={handleEdit} showDelete={handleDelete} show={showRowOffcanvas} handleClose={handleCloseRowOffcanvas} />
          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr
                      key={row.id}
                      style={{
                        position: "relative",
                        backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                        cursor: "pointer",
                        transition: "border-color 0.3s",
                        borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => handleRowClick(row.original.id)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
